import { UserInformationBasic } from '@/api'
import { RadioTab, Space } from '@/components/core-v2'

import { Mutation } from '../types'

export const RoleSection = ({
  onMutate,
  user
}: {
  onMutate: (mutation: Mutation<UserInformationBasic>) => void
  user: UserInformationBasic
}) => (
  <div>
    <Space mb={3}>
      <label className="radio-group" htmlFor="edit-pm">
        Role
      </label>
    </Space>
    <Space isflex id="edit-pm">
      <Space mr={5}>
        <RadioTab
          data-testid="role-1-option"
          isSelected={user.roles.includes('Editor')}
          onClick={() =>
            onMutate(u => {
              if (!u.roles.includes('Editor')) {
                u.roles.push('Editor')
              }
              u.roles = u.roles.filter(x => x !== 'BusinessUnitUser')
            })
          }
        >
          Editor
        </RadioTab>
      </Space>
      <Space>
        <RadioTab
          data-testid="role-2-option"
          isSelected={user.roles.includes('BusinessUnitUser')}
          onClick={() =>
            onMutate(u => {
              if (!u.roles.includes('BusinessUnitUser')) {
                u.roles.push('BusinessUnitUser')
              }
              u.roles = u.roles.filter(x => x !== 'Editor')
            })
          }
        >
          View only
        </RadioTab>
      </Space>
    </Space>
  </div>
)
